import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { ChangePasswordComponent } from './change-password.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    ChangePasswordComponent
  ],
  exports:[ChangePasswordComponent]
})
export class ChangePasswordModule { }



// WEBPACK FOOTER //
// ./src/app/component/change-password/change-password.module.ts